import {useState} from "react";
import MainBanner from "../avoskin-trail-run/main-banner";
import Sidebar from "../../components/static-page/sidebar.component";
import {SECTION_AVOSKIN_TRAIL_RUN} from "../../utils/sidebar-section-list";
import PartnersAndSponsors from "./partners-and-sponsors";
import AboutTrailRun from "./about-trail-run";
import MindBodyEnvironment from "./mind-body-environment";
import MainEvents from "./main-events";
import RaceCategory from "./race-category";

const AvoskinTrailRunPage = () => {
    const [activeSidebar, setActiveSidebar] = useState('main_banner')

    const onChangeSidebar = (key) => {
        setActiveSidebar(key)
    }

    const content = {
        main_banner: <MainBanner/>,
        about_avoskin_trail_run: <AboutTrailRun/>,
        mind_body_environment: <MindBodyEnvironment/>,
        main_events: <MainEvents/>,
        race_category: <RaceCategory/>,
        partners_and_sponsors: <PartnersAndSponsors/>,
    }

    return (
        <div className={"row px-10 space-x-5 py-5"}>
            <div className={"w-1/5"}>
                <Sidebar section={{page: 'avoskin-trail-run', list: SECTION_AVOSKIN_TRAIL_RUN}}
                         onChange={onChangeSidebar} activeSidebar={activeSidebar}/>
            </div>
            <div className={"w-4/5"}>
                {content[activeSidebar]}
            </div>
        </div>
    )
}

export default AvoskinTrailRunPage
